module.exports = __webpack_public_path__ + "img/digio-c.62ba9e94.svg";